import { render, staticRenderFns } from "./settlementList.vue?vue&type=template&id=3180faee"
import script from "./settlementList.vue?vue&type=script&lang=js"
export * from "./settlementList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports